import React from 'react'
import { Grid } from "@mui/material";
import Stack from '@mui/material/Stack';
import UiInput from '../../../_uiComponents/UiInput';
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../_uiComponents/common/UiInnerSearchWr';
import UiDateRangePicker from '../../../_uiComponents/UiDateRangePicker';


export default function NewsFeedFilterForm(props) {

    return (
        <>
            <UiInnerSearchWr>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={9} >
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={4} className='sba-search-input' >
                                <UiInput type="text" label="Name" />
                            </Grid>                           
                            <Grid item xs={12} lg={4} >
                                <UiDateRangePicker />
                            </Grid>
                        </Grid>
                    </Grid>
                        <Grid item xs={12} lg={3} >
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%',pt:0.6  }}>
                                <UiButton name="Clear" variant="outlined" size="small" />
                                <UiButton name="Apply" variant="contained" size="small" />
                            </Stack>
                        </Grid>
                   
                </Grid>
            </UiInnerSearchWr>

        </>
    )
}
